import { useState } from "react";

export default function ModeToggle() {
  const [mode, setMode] = useState<"REAL" | "VIRTUAL">(() => {
    return (localStorage.getItem("bazaar_mode") as "REAL" | "VIRTUAL") || "VIRTUAL";
  });

  const toggle = () => {
    const next = mode === "REAL" ? "VIRTUAL" : "REAL";
    setMode(next);
    localStorage.setItem("bazaar_mode", next);
  };

  const isReal = mode === "REAL";

  return (
    <button
      onClick={toggle}
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 8,
        background: isReal ? "rgba(46,125,50,0.15)" : "rgba(245,158,11,0.15)",
        border: `1px solid ${isReal ? "var(--green)" : "var(--amber)"}`,
        borderRadius: 6,
        padding: "6px 10px",
        cursor: "pointer",
        color: isReal ? "var(--green-light)" : "var(--amber)",
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 0.5,
      }}
    >
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          background: isReal ? "var(--green-light)" : "var(--amber)",
        }}
      />
      {isReal ? "REAL MODE" : "VIRTUAL MODE"}
    </button>
  );
}
